import { MembershipValue } from "../constants/membershipDomainConstants";
import { clients, GET_INSPIRED_PLACEMENT, placements } from "../constants/moduleConstants";

// All of this is Partial to allow for backwards compatibility
type ConstructOneDataBodyParams = Partial<{
  locale: string;
  clientId: typeof clients extends Set<infer T> ? T : never;
  placementId: typeof placements extends Set<infer T> ? T : never;
}>;

type MembershipData = {
  data: {
    membership?: MembershipValue[];
  }
}

export const constructOneDataBody = (
  {
    locale, clientId, placementId
  }: ConstructOneDataBodyParams,
  membershipData?: MembershipData
) => {
  let oneDataBody: Record<string, unknown> = {
    clientId,
    placementId,
    locale,
  };

  switch (placementId) {
    case GET_INSPIRED_PLACEMENT:
      let accountToken = membershipData?.data?.membership
        ?.find((membership: MembershipValue) => membership?.demographics?.isTopCard)
          ?.accountToken;

      oneDataBody.personalizationParam = accountToken
      break;

    default:
      break;
  }

  return oneDataBody;
}
